import { useState } from 'react';
import Icon from '../Icon';
import ConfirmationModal from '../ConfirmationModal';
import './close-button.css';

function CloseButton({
    onClick = () => {},
    shouldConfirm = false,
    confirmTitle = 'Sair sem salvar',
    confirmDescription = 'Você tem alterações não salvas. Deseja realmente sair e perder as informações?'
}) {
    const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);

    function onClickClose(e) {
        e.preventDefault();

        if (shouldConfirm) {
            setShowCloseConfirmation(true);
            return;
        }

        onClick();
    }

    function onConfirmClose() {
        setShowCloseConfirmation(false);
        onClick();
    }

    return (
        <>
            <div className='close-container'>
                <button
                    type='button'
                    className='close-button'
                    onClick={onClickClose}>
                    <Icon iconClass='icon-close' size={16} />
                </button>
            </div>

            <ConfirmationModal
                show={showCloseConfirmation}
                title={confirmTitle}
                description={confirmDescription}
                onConfirm={onConfirmClose}
                onClose={() => setShowCloseConfirmation(false)}
            />
        </>
    );
}

export default CloseButton;